/**
 * The Manage tab's Onboarding templates sub-view addresses (plan
 * docs/plans/lms-plan.md 18.3: Manage sub-view path "onboarding-templates",
 * mounted under onboarding-templates/* so this sub-view routes its own
 * template editor; WP-47).
 */

/** The template list: /lms/manage/onboarding-templates */
export const TEMPLATES_BASE = '/lms/manage/onboarding-templates';

/** One template's editor: /lms/manage/onboarding-templates/<templateId> */
export function templateHref(templateId: string): string {
  return `${TEMPLATES_BASE}/${encodeURIComponent(templateId)}`;
}
